// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually
import React from 'react';

const IconCheckRound = (props: React.SVGProps<SVGElement>) =>
  /*#__PURE__*/ React.createElement(
    'svg',
    {
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      xmlns: 'http://www.w3.org/2000/svg',
      ...props
    },
    /*#__PURE__*/ React.createElement('rect', {
      x: '2.5',
      y: '2.5',
      width: '19',
      height: '19',
      rx: '3.5',
      fill: 'current',
      stroke: '#114FBE'
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.8 8.3999L9.64043 15.5999L7.19995 13.1456',
      stroke: 'current',
      strokeWidth: '2',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    })
  );

export { IconCheckRound };
